window.moment = require('moment');
window.$ = require('jquery');
require('jquery-form');
require('jquery-datetimepicker');
// window.dragula = require('dragula');
window.popper = require('popper.js');
window.Popper = window.popper.default;

global.jQuery = require('jquery');
require('bootstrap-toggle');
require('jquery-ui');
require('spectrum-colorpicker/spectrum.js')



// WEBPACK FOOTER //
// ./devel/vendor.js